import { useModalStore } from "@/stores/modalStore";
import { useRouter } from "vue-router";

export function useOpenProfile() {
  const modalStore = useModalStore();
  const router = useRouter();

  function openProfile(id) {
    if (!id) return;

    modalStore.closeAllModals();

    router.push({
      name: "UserProfile",
      params: { id },
    });
  }

  return { openProfile };
}
